import * as _ from 'lodash';
import { IClcScoresSummary, IUser } from '@nkr/models/index';
import { GridWrapper } from './styles';
import { AgGridReact, AgGridColumnProps, AgGridColumnGroupProps } from 'ag-grid-react';
import {
    IHeaderParams, GridApi, ColumnApi, GridReadyEvent,
    ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, SortChangedEvent
} from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { useState } from 'react';

type MyColumn = AgGridColumnProps | AgGridColumnGroupProps;

interface IProps {
    list: IClcScoresSummary[],
    centerId: number,
    isAdmin: boolean
}

const CenterCLCScoresGrid = (props: IProps) => {
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [columns, setColumns] = useState<MyColumn[]>([
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Rank
                </SortableHeaderComponent>,
            headerName: 'Rank',
            width: 60,
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'alias',
            field: 'alias',
            headerName: 'Center',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Center
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IClcScoresSummary;
                let { id, alias } = data;

                if (isAdmin) {
                    return <a target={'_blank'} href={`/admin/reports/clc/clc-score-details/${id}`}>{alias}</a>;
                }

                if (id == centerId) {
                    return <a target={'_blank'} href={`/center/${centerId}/reports/clc/clc-score-details`}>{alias}</a>
                } else {
                    return <div>{alias}</div>
                }
            },
            width: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'ndd',
            field: 'ndd',
            headerName: 'NDD',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    NDD
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'etmp',
            field: 'etmp',
            headerName: 'Easy To Match Pairs',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Easy To<br />Match Pairs
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'htmp',
            field: 'htmp',
            headerName: 'Hard To Match Pairs',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Hard To<br />Match Pairs
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'matchFailures',
            field: 'matchFailures',
            headerName: 'Swap Failure',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Swap <br /> Failure
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'htmd',
            field: 'htmd',
            headerName: 'Hard to Match Donors Accepted',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Hard to <br /> Match Donors <br /> Accepted
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'ncs',
            field: 'ncs',
            headerName: 'Net Chains Started',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Net Chains <br /> Started
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'rdn',
            field: 'rdn',
            headerName: 'Remote Donation',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Remote <br /> Donation
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'fndd',
            field: 'fndd',
            headerName: 'Forecasted Non Directed Donors',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Forecasted <br />Non Directed <br />Donors
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'fetmp',
            field: 'fetmp',
            headerName: 'Forecasted Easy to Match Pairs',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Forecasted <br />Easy to <br />Match Pairs
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'fhtmp',
            field: 'fhtmp',
            headerName: 'Forecasted Hard to Match Pairs',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Forecasted <br />Hard to <br />Match Pairs
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'fncs',
            field: 'fncs',
            headerName: 'Forecasted Net Chains Started',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Forecasted <br />Net Chains <br />Started
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'fhtmd',
            field: 'fhtmd',
            headerName: 'Forecasted Hard to Match Donors Accepted',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Forecasted <br />Hard to <br />Match Donors <br /> Accepted
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'surgDeclines',
            field: 'surgDeclines',
            headerName: 'Surg PS Declines for CLC Targets',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Surg PS <br />Declines for <br />CLC Targets
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'clc',
            field: 'clc',
            headerName: 'Actual CLC Score',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Actual<br /> CLC Score
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },

        {
            colId: 'fclc',
            field: 'fclc',
            headerName: 'Forecasted CLC Score',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Forcasted<br /> CLC Score
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'uclc',
            field: 'uclc',
            headerName: 'Usable CLC Score',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Usable<br /> CLC Score
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'clco',
            field: 'clco',
            headerName: 'CLC Offers',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    CLC<br /> Offers
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'clct',
            field: 'clct',
            headerName: 'CLC Transplants',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    CLC<br /> Transplants
                </SortableHeaderComponent>,
            width: 95,
            sortable: true,
            // sort: 'asc',
            resizable: true
        }
    ]);

    const onGridReady = (e: GridReadyEvent) => {
        setGridApi(e.api);
        setColumnApi(e.columnApi);
        e.api.sizeColumnsToFit();
    };

    const isAdmin = props.isAdmin;
    const centerId = props.centerId;

    return (
        <>
            <div className='row'>
                <div className='col-sm-12'>
                    <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 5 }}>
                        <AgGridReact
                            enableCellTextSelection={true}
                            enableRangeSelection={true}
                            columnDefs={columns}
                            rowData={props.list}
                            headerHeight={65}
                            noRowsOverlayComponentFramework={() =>
                                <div>No data for the selected date range...</div>}
                            onGridReady={onGridReady}
                            onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            suppressCellSelection={true}
                            onSortChanged={(e: SortChangedEvent) => { e.api.refreshCells(); }}
                            getRowStyle={(params: any) => {
                                if (!isAdmin && params.data.id == centerId) {
                                    return { background: 'yellow' };
                                }

                                return null;
                            }}
                        />
                    </GridWrapper>
                </div>
            </div>
        </>
    );
}

export default CenterCLCScoresGrid;